<h3>Soft-skills Objections & Questions</h3>
<nz-table
  class="full-width"
  #emotionalObjectionTable
  [nzData]="emotionalObjectionList"
  [nzPaginationType]="'small'"
  [nzPageSize]="8"
>
  <thead>
    <tr>
      <th [nzWidth]="'250px'">Question</th>
      <th>Your Answer</th>
      <th>Score</th>
      <th>Suggestions</th>
      <th>Improved Response</th>
      <th>Example</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    @for (objection of emotionalObjectionTable.data; track objection.id; let i = $index) {
      <tr>
        <td>{{ objection.title }}</td>
        <td>{{ getMyAnswer(objection.id)?.subData?.salesMessage }}</td>
        <td>{{ getMyAnswer(objection.id)?.subData?.objectionScore }}</td>
        <td>{{ getMyAnswer(objection.id)?.subData?.objectionSuggestions }}</td>
        <td>{{ getMyAnswer(objection.id)?.subData?.objectionImprovedResponse }}</td>
        <td>
          <button nz-button nzType="text" nzSize="small" [matTooltip]="objection.description">
            <span nz-icon style="font-size: 16px" class="material-symbols-rounded">info</span>
          </button>
        </td>
        <td>
          <button nz-button nzType="default" nzSize="small" (click)="onSoftSkillsEvaluateClick(objection)">
            Evaluate
          </button>
        </td>
      </tr>
    }
  </tbody>
</nz-table>

<h3>Facts-based Objections & Questions</h3>
<nz-table
  class="full-width"
  #factObjectionTable
  [nzData]="factObjectionList"
  [nzPaginationType]="'small'"
  [nzPageSize]="8"
>
  <thead>
    <tr>
      <th [nzWidth]="'250px'">Question</th>
      <th>Your Answer</th>
      <th>Score</th>
      <th>Potential Information Gaps</th>
      <th>Reason</th>
      <th>Possible Inaccurate Information</th>
      <th>Reason</th>
      <th>Example</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    @for (objection of factObjectionTable.data; track objection.id; let i = $index) {
      <tr>
        <td>{{ objection.title }}</td>
        <td>{{ objection.description }}</td>
        <td>{{ getMyAnswer(objection.id)?.subData?.objectionScore }}</td>
        <td>
          @for (item of getMyAnswer(objection.id)?.subData?.objectionMissingInformationList; track $index) {
            <ul>
              <li>{{ item.missingInformation }}</li>
            </ul>
          }
        </td>
        <td>
          @for (item of getMyAnswer(objection.id)?.subData?.objectionMissingInformationList; track $index) {
            <ul>
              <li>{{ item.reasoning }}</li>
            </ul>
          }
        </td>
        <td>
          @for (item of getMyAnswer(objection.id)?.subData?.objectionInaccurateInformationList; track $index) {
            <ul>
              <li>{{ item.inaccurateInformation }}</li>
            </ul>
          }
        </td>
        <td>
          @for (item of getMyAnswer(objection.id)?.subData?.objectionInaccurateInformationList; track $index) {
            <ul>
              <li>{{ item.reasoning }}</li>
            </ul>
          }
        </td>
        <td>
          <button nz-button nzType="text" nzSize="small" [matTooltip]="objection.description">
            <span nz-icon style="font-size: 16px" class="material-symbols-rounded">info</span>
          </button>
        </td>
        <td>
          <button nz-button nzType="default" nzSize="small" (click)="onFactsBasedEvaluateClick(objection)">
            Evaluate
          </button>
        </td>
      </tr>
    }
  </tbody>
</nz-table>
